"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestOrgSettings = exports.OrgSettings = void 0;
const AssetCustomFieldNames_1 = require("@opsbase/lib-asset/AssetCustomFieldNames");
const AssetType_1 = require("@opsbase/lib-asset/AssetType");
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const backwardCompatChart_1 = __importDefault(require("@opsbase/lib-chart/helpers/backwardCompatChart"));
const Measure_1 = __importDefault(require("@opsbase/lib-chart/Measure"));
const backwardCompatQuery_1 = __importDefault(require("@opsbase/lib-data-query/helpers/backwardCompatQuery"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const DefaultGradeKeys_1 = __importDefault(require("@opsbase/lib-grading/DefaultGradeKeys"));
const DefaultGrades_1 = __importDefault(require("@opsbase/lib-grading/DefaultGrades"));
const DefaultGradingCalculatorKey_1 = __importDefault(require("@opsbase/lib-grading/DefaultGradingCalculatorKey"));
const DefaultGradingCalculators_1 = __importDefault(require("@opsbase/lib-grading/DefaultGradingCalculators"));
const Grade_1 = __importDefault(require("@opsbase/lib-grading/Grade"));
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const Flag_1 = __importStar(require("@opsbase/lib-issue/Flag"));
const IssueType_1 = __importStar(require("@opsbase/lib-issue/IssueType"));
const OpType_1 = __importStar(require("@opsbase/lib-op/OpType"));
const TimeInterval_1 = __importDefault(require("@opsbase/lib-time/TimeInterval"));
const merge_1 = __importDefault(require("lodash/merge"));
class OrgSettings {
    constructor(o = {}) {
        var _a, _b, _c;
        this.languages = [Language_1.default.ENGLISH];
        this.defaultOpsLogLmssId = 'last7days';
        this.defaultIssuesLogLmssId = 'openissues';
        this.mandatoryOpsLogLmssIds = ['allops', 'last7days', 'yesterday'];
        this.mandatoryIssuesLogLmssIds = ['allissues', 'openissues', 'issuesyesterday'];
        this.dashboardWidgets = [
            {
                title: 'Operations overall punctuality per Place per Week',
                key: 'perf_place_table',
                coords: {
                    x: 0,
                    y: 0,
                    w: 6,
                    h: 7,
                },
                chart: {
                    key: 'perf_place_table',
                    chartType: ChartType_1.default.TABLE3D,
                    chartVariant: ChartVariant_1.default.PERF_GROUP_TIME,
                    config: {
                        dimension: QueryFieldKey_1.default.PLACE,
                        measure: Measure_1.default.PUNCTUALITY,
                        interval: TimeInterval_1.default.WEEK,
                    },
                },
            },
            {
                title: 'Operations overall punctuality per Place per Week',
                key: 'perf_place_line',
                coords: {
                    x: 6,
                    y: 0,
                    w: 6,
                    h: 7,
                },
                chart: {
                    key: 'perf_place_line',
                    chartType: ChartType_1.default.LINE3DGROUP,
                    chartVariant: ChartVariant_1.default.PERF_GROUP_TIME,
                    config: {
                        dimension: QueryFieldKey_1.default.PLACE,
                        measure: Measure_1.default.PUNCTUALITY,
                        interval: TimeInterval_1.default.WEEK,
                    },
                },
            },
            {
                title: 'Operations overall punctuality per Operation per Week',
                key: 'perf_opdef_table',
                coords: {
                    x: 0,
                    y: 7,
                    w: 6,
                    h: 7,
                },
                chart: {
                    key: 'perf_opdef_table',
                    chartType: ChartType_1.default.TABLE3D,
                    chartVariant: ChartVariant_1.default.PERF_GROUP_TIME,
                    config: {
                        dimension: QueryFieldKey_1.default.OPDEFINITION,
                        measure: Measure_1.default.PUNCTUALITY,
                        interval: TimeInterval_1.default.WEEK,
                    },
                },
            },
            {
                title: 'Operations overall punctuality per Operation per Week',
                key: 'perf_opdef_line',
                coords: {
                    x: 6,
                    y: 7,
                    w: 6,
                    h: 7,
                },
                chart: {
                    key: 'perf_opdef_line',
                    chartType: ChartType_1.default.LINE3DGROUP,
                    chartVariant: ChartVariant_1.default.PERF_GROUP_TIME,
                    config: {
                        dimension: QueryFieldKey_1.default.OPDEFINITION,
                        measure: Measure_1.default.PUNCTUALITY,
                        interval: TimeInterval_1.default.WEEK,
                    },
                },
            },
        ];
        Object.assign(this, o);
        this.flagNames = (o === null || o === void 0 ? void 0 : o.flagNames) || Flag_1.DefaultFlagNamesMap;
        this.issueTypes = [...((o === null || o === void 0 ? void 0 : o.issueTypes) || IssueType_1.DefaultIssueTypes)];
        if (!((_a = this.issueTypes) === null || _a === void 0 ? void 0 : _a.find(i => i.key === IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED))) {
            this.issueTypes.push(new IssueType_1.default(IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED, 'Unspecified'));
        }
        this.opTypes = [...((o === null || o === void 0 ? void 0 : o.opTypes) || OpType_1.DefaultOpTypes)];
        if (!this.opTypes.find(i => i.key === OpType_1.DefaultOpTypeKeys.UNSPECIFIED)) {
            this.opTypes.push(new OpType_1.default(OpType_1.DefaultOpTypeKeys.UNSPECIFIED, 'Unspecified'));
        }
        this.assetTypes = [...((o === null || o === void 0 ? void 0 : o.assetTypes) || AssetType_1.DefaultAssetTypes)];
        if (!this.assetTypes.find(i => i.key === AssetType_1.DefaultAssetTypeKeys.UNSPECIFIED)) {
            this.assetTypes.push(new OpType_1.default(AssetType_1.DefaultAssetTypeKeys.UNSPECIFIED, 'Unspecified'));
        }
        this.grades = [...((o === null || o === void 0 ? void 0 : o.grades) || DefaultGrades_1.default)];
        if (!this.grades.find(i => i.key === DefaultGradeKeys_1.default.UNDETERMINED)) {
            this.grades.push(new Grade_1.default(DefaultGradeKeys_1.default.UNDETERMINED, 'Undetermined'));
        }
        this.gradingCalculators = [...((o === null || o === void 0 ? void 0 : o.gradingCalculators) || DefaultGradingCalculators_1.default)];
        if (!this.gradingCalculators.find(i => i.key === DefaultGradingCalculatorKey_1.default)) {
            this.gradingCalculators.push(DefaultGradingCalculators_1.default.find(v => v.key === DefaultGradingCalculatorKey_1.default));
        }
        this.integrations = o === null || o === void 0 ? void 0 : o.integrations;
        (_b = this.dashboardWidgets) === null || _b === void 0 ? void 0 : _b.forEach(d => {
            (0, backwardCompatQuery_1.default)(d.query);
            (0, backwardCompatChart_1.default)(d.chart);
        });
        this.assetCustomFieldNames = (_c = o === null || o === void 0 ? void 0 : o.assetCustomFieldNames) !== null && _c !== void 0 ? _c : AssetCustomFieldNames_1.defaultAssetCustomFieldNames;
    }
    getIssueTypeTitle(key) {
        if (this.issueTypes) {
            const it = this.issueTypes.find(iit => iit.key === key);
            if (it) {
                return it.title;
            }
        }
        return 'Unspecified';
    }
    getIssueTypeRequirements(key) {
        var _a;
        if (this.issueTypes) {
            const it = this.issueTypes.find(iit => iit.key === key);
            if (it) {
                return it.requirements || [];
            }
        }
        return (((_a = this.issueTypes.find(it => it.key === IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED)) === null || _a === void 0 ? void 0 : _a.requirements) ||
            []);
    }
    getOpTypeTitle(key) {
        if (this.opTypes) {
            const it = this.opTypes.find(iit => iit.key === key);
            if (it) {
                return it.title;
            }
        }
        return 'Unspecified';
    }
    getAssetTypeTitle(key) {
        if (this.assetTypes) {
            const it = this.assetTypes.find(iit => iit.key === key);
            if (it) {
                return it.title;
            }
        }
        return 'Unspecified';
    }
    getGradingCalculatorTitle(key) {
        if (this.gradingCalculators) {
            const it = this.gradingCalculators.find(iit => iit.key === key);
            if (it) {
                return it.title;
            }
        }
        return '- - -';
    }
    getFlagName(key) {
        return this.flagNames ? this.flagNames[key] || 'Uncategorised' : 'Uncategorised';
    }
    static merge(oldSettings, newSettings) {
        const r = Object.assign({}, oldSettings);
        if (newSettings.flagNames)
            r.flagNames = newSettings.flagNames;
        if (newSettings.issueTypes)
            r.issueTypes = newSettings.issueTypes;
        if (newSettings.opTypes)
            r.opTypes = newSettings.opTypes;
        if (newSettings.assetTypes)
            r.assetTypes = newSettings.assetTypes;
        if (newSettings.grades)
            r.grades = newSettings.grades;
        if (newSettings.gradingCalculators)
            r.gradingCalculators = newSettings.gradingCalculators;
        if (newSettings.integrations)
            r.integrations = (0, merge_1.default)(oldSettings === null || oldSettings === void 0 ? void 0 : oldSettings.integrations, newSettings.integrations);
        if (newSettings.logoId)
            r.logoId = newSettings.logoId;
        if (newSettings.titleColor)
            r.titleColor = newSettings.titleColor;
        if (newSettings.languages)
            r.languages = newSettings.languages;
        if (newSettings.assetCustomFieldNames)
            r.assetCustomFieldNames = newSettings.assetCustomFieldNames;
        if (newSettings.defaultOpsLogLmssId)
            r.defaultOpsLogLmssId = newSettings.defaultOpsLogLmssId;
        if (newSettings.defaultIssuesLogLmssId)
            r.defaultIssuesLogLmssId = newSettings.defaultIssuesLogLmssId;
        if (newSettings.mandatoryIssuesLogLmssIds)
            r.mandatoryIssuesLogLmssIds = newSettings.mandatoryIssuesLogLmssIds;
        if (newSettings.mandatoryOpsLogLmssIds)
            r.mandatoryOpsLogLmssIds = newSettings.mandatoryOpsLogLmssIds;
        if (newSettings.dashboardWidgets)
            r.dashboardWidgets = newSettings.dashboardWidgets;
        if (newSettings.notificationRules)
            r.notificationRules = newSettings.notificationRules;
        return r;
    }
}
exports.OrgSettings = OrgSettings;
exports.TestOrgSettings = new OrgSettings({
    languages: [Language_1.default.ENGLISH, Language_1.default.DANISH, Language_1.default.SPANISH],
    flagNames: {
        [Flag_1.default.RED]: 'Expedite',
        [Flag_1.default.ORANGE]: 'Normal',
        [Flag_1.default.GREEN]: 'Trivial',
        [Flag_1.default.BLACK]: 'Back Burner',
        [Flag_1.default.PURPLE]: 'Not an issue',
        [Flag_1.default.BLUE]: 'Icebox',
    },
    issueTypes: [
        new IssueType_1.default('operational', 'Operational'),
        new IssueType_1.default('maintenance', 'Maintenance'),
        new IssueType_1.default('cleaning', 'Cleaning'),
        new IssueType_1.default('safe', 'Safety'),
        new IssueType_1.default('food', 'Food'),
        new IssueType_1.default('health', 'Health'),
    ],
});
exports.default = OrgSettings;
